import type { SpreadsheetColumnId } from '~/_shared/types/spreadsheetData/spreadsheetColumn';
import type { SpreadsheetId } from '~/_shared/types/spreadsheetData/spreadsheetRow';
import { createUuid } from '~/_shared/utils/createUuid';
import {
  type ChartBoundaryStatistics, type ChartId, type ChartMetricDemographic, type ChartMetricLocationCount,
  type ChartMetricSpreadsheetColumn, ChartMetricType, ChartType,
} from './mapSettingsCharts.types';

export const createChartId = (): ChartId => createUuid();

export const createChartBoundaryStatistics = ({
  title, metrics, boundaryGroupId, shouldNormalize, id,
}: { boundaryGroupId: ChartBoundaryStatistics['boundaryGroupId'] } & Partial<ChartBoundaryStatistics>): ChartBoundaryStatistics => ({
  type: ChartType.BoundaryStatistics,
  id: id || createChartId(),
  title,
  metrics: metrics || [],
  boundaryGroupId,
  shouldNormalize,
});

export const createChartMetricSpreadsheetColumn = (
  column: SpreadsheetColumnId
): ChartMetricSpreadsheetColumn => {
  return {
    type: ChartMetricType.SpreadsheetColumn,
    column,
  };
};

export const createChartMetricLocationCount = (
  spreadsheetId?: SpreadsheetId,
  column?: SpreadsheetColumnId,
  columnValue?: string,
): ChartMetricLocationCount => {
  return {
    type: ChartMetricType.LocationCount,
    column,
    columnValue,
    // if column is provided, this won't be a location count metric for all locations in the spreadsheet,
    // which would require the spreadsheetId
    spreadsheetId: column ? undefined : spreadsheetId,
  };
};

export const createChartMetricDemographic = (
  demographicId: string
): ChartMetricDemographic => {
  return {
    type: ChartMetricType.Demographic,
    demographicId,
  };
};
